import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';

function AppLogo({
    src = '/assets/images/app_logo.png',
    iconName = 'SparklesIcon',
    size = 64,
    className = '',
    onClick,
}) {
    const containerClassName = useMemo(() => {
        const classes = ['flex items-center'];
        if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
        if (className) classes.push(className);
        return classes.join(' ');
    }, [onClick, className]);

    return (
        <div className={containerClassName} onClick={onClick}>
            {src ? (
                <img
                    src={src}
                    alt="Logo"
                    width={size}
                    height={size}
                    className="flex-shrink-0 object-contain"
                    onError={(e) => {
                        e.target.src = '/logo192.png';
                    }}
                />
            ) : (
                <AppIcon name={iconName} size={size} className="flex-shrink-0" />
            )}
        </div>
    );
}

export default memo(AppLogo);